export default {
    START: 0,
    STEP1: 1,
    STEP2: 2,
    STEP3: 3,
    CONFIRMATION: 4
};
